import {Fragment, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconButton} from "@mui/material";
import {ConfirmDialog} from "@dvrt/graphql-widgets";
import {showNotification} from "../../actions";
import {useDispatch} from "react-redux";
import {defineMessage} from "react-intl";
import {useDeletePickupGroupMutation} from "@/mutations.generated";
import {CONFIRM_MESSAGES} from "@/utils/translations";

type Props = {
    id: number;
    name: string;
    onSuccess?: () => void;
};

export default ({id, name, onSuccess}: Props) => {
    const [isDialogOpen, setDialogOpen] = useState(false);
    const dispatch = useDispatch();

    const [mutation] = useDeletePickupGroupMutation({
        onCompleted(data) {
            if (data.deletePickupGroup.length) {
                dispatch(
                    showNotification(
                        defineMessage({id: "unexpected_error", defaultMessage: "Unexpected error"}),
                        "error",
                    ),
                );
                return;
            }

            dispatch(
                showNotification(
                    defineMessage({id: "pickup_group_deleted", defaultMessage: "Pickup group deleted"}),
                    "success",
                ),
            );
            if (onSuccess) onSuccess();
        },

        onError() {
            dispatch(
                showNotification(defineMessage({id: "unexpected_error", defaultMessage: "Unexpected error"}), "error"),
            );
        },
    });

    return (
        <Fragment>
            <IconButton color="secondary" onClick={() => setDialogOpen(true)} size="small">
                <FontAwesomeIcon icon="trash" />
            </IconButton>
            <ConfirmDialog
                isOpen={isDialogOpen}
                close={() => setDialogOpen(false)}
                onConfirm={() => mutation({variables: {id}})}
                message={CONFIRM_MESSAGES.delete_pickup_group}
                messageVars={{name}}
                buttonIdPrefix="delete-pickup-group"
            />
        </Fragment>
    );
};
